export default function CandyMatchIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <radialGradient id="cm-r" cx="35%" cy="30%" r="70%">
          <stop offset="0" stopColor="#ffb3c1" />
          <stop offset="0.5" stopColor="#ff4d6d" />
          <stop offset="1" stopColor="#a3102f" />
        </radialGradient>
        <radialGradient id="cm-b" cx="35%" cy="30%" r="70%">
          <stop offset="0" stopColor="#b5dbff" />
          <stop offset="0.5" stopColor="#3aa0ff" />
          <stop offset="1" stopColor="#0d4f99" />
        </radialGradient>
        <radialGradient id="cm-y" cx="35%" cy="30%" r="70%">
          <stop offset="0" stopColor="#fff6b8" />
          <stop offset="0.5" stopColor="#ffe14d" />
          <stop offset="1" stopColor="#a88a00" />
        </radialGradient>
        <radialGradient id="cm-p" cx="35%" cy="30%" r="70%">
          <stop offset="0" stopColor="#e2c2ff" />
          <stop offset="0.5" stopColor="#b45cff" />
          <stop offset="1" stopColor="#5f1a9e" />
        </radialGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#4a2380" />
      {/* Big heart sweet with a rocket arrow. */}
      <path d="M32 46C14 34 18 14 32 23C46 14 50 34 32 46Z" fill="url(#cm-r)" stroke="#a3102f" strokeWidth="2" />
      <path d="M20 30l5-4v2.5h14V26l5 4-5 4v-2.5H25V34z" fill="#fff" stroke="#a3102f" strokeWidth="1" />
      {/* Gem, star and moon. */}
      <path d="M8 52l3-4h6l3 4-6 8z" fill="url(#cm-b)" stroke="#0d4f99" strokeWidth="1" />
      <path d="M32 47l2.6 5.2 5.6.6-4.2 3.8 1.2 5.6-5.2-3-5.2 3 1.2-5.6-4.2-3.8 5.6-.6z" fill="url(#cm-y)" stroke="#a88a00" strokeWidth="1" />
      <path d="M53 47a7 7 0 1 0 5 11a5.5 5.5 0 1 1-5-11z" fill="url(#cm-p)" stroke="#5f1a9e" strokeWidth="1" />
      <path d="M48 6l3 3M54 4v4M58 8l-3 2" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
